import { ChevronDown, ChevronUp } from 'lucide-react';

interface TimelineItemProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  badge?: string;
  expandable?: boolean;
  expanded?: boolean;
  children?: React.ReactNode;
}

export const TimelineItem: React.FC<TimelineItemProps> = ({
  icon,
  title,
  subtitle,
  badge,
  expandable,
  expanded,
  children,
}) => {
  return (
    <div className="relative w-full pl-14">
      {/* Icon */}
      <div className="absolute left-0 top-0.5 flex h-[35px] w-[35px] items-center justify-center rounded-full bg-primary shadow">
        {icon}
      </div>

      <div className="pt-2 border-t-2 border-gray-300" />

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-7">
          <div>
            <h4 className="text-sm font-semibold leading-5 text-secondary">{title}</h4>
            <p className="text-[13px] leading-5 text-secondary/80">{subtitle}</p>
          </div>
          {badge && (
            <span className="bg-[#FFB00E] text-xs font-normal px-3 py-1 rounded-full text-[#2B3038]">
              {badge}
            </span>
          )}
        </div>

        {expandable &&
          (expanded ? (
            <ChevronUp className="h-5 w-5 cursor-pointer text-secondary/80" />
          ) : (
            <ChevronDown className="h-5 w-5 cursor-pointer text-secondary/80" />
          ))}
      </div>

      {children && <div className="mt-4">{children}</div>}
    </div>
  );
};
